import { Component, Input, OnInit } from '@angular/core';
import { IMenuItem } from '../menu-base/menu-base.component';

@Component({
  selector: 'app-menu-section-button',
  templateUrl: './menu-section-button.component.html',
  styleUrls: ['./menu-section-button.component.scss']
})
export class MenuSectionButtonComponent implements OnInit {
    @Input() item: IMenuItem;
    constructor() { }

    ngOnInit(): void {
    }

}
